// Global delegated handler for the "Order Now — Pay on Delivery" buttons across all product pages,
// PLUS a submit-level guard so Craft's native "Add to Cart" button also respects required fields.
// Blocked state now shows a persistent, unmissable warning message instead of a brief flash.
(function () {
  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
  }

  function findEmptyRequiredField(formId) {
    var externalFields = document.querySelectorAll('[form="' + formId + '"]');
    for (var i = 0; i < externalFields.length; i++) {
      var f = externalFields[i];
      var isEmpty = f.type === 'file' ? f.files.length === 0 : !f.value.trim();
      if (f.hasAttribute('required') && isEmpty) return f;
    }
    return null;
  }

  function showWarning(field) {
    field.classList.add('cc-field-error');
    field.focus();
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var block = field.closest('.cc-personalize-block');
    if (!block) return;
    var msg = block.querySelector('.cc-field-warning');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'cc-field-warning';
      msg.textContent = 'Please fill this in before you can place your order.';
      block.appendChild(msg);
    }
    msg.style.display = 'block';

    var clearWarning = function () {
      msg.style.display = 'none';
      field.classList.remove('cc-field-error');
      field.removeEventListener('input', clearWarning);
      field.removeEventListener('change', clearWarning);
    };
    field.addEventListener('input', clearWarning);
    field.addEventListener('change', clearWarning);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.id || !form.id.indexOf) return;
    if (form.id.indexOf('product-form-') !== 0) return;
    var emptyField = findEmptyRequiredField(form.id);
    if (emptyField) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showWarning(emptyField);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cc-btn-primary');
    if (!btn) return;
    e.preventDefault();

    var formId = btn.getAttribute('data-cc-form-id');
    if (!formId) { console.error('Classic Collection: Order Now button missing data-cc-form-id'); return; }
    var form = document.getElementById(formId);
    if (!form) { console.error('Classic Collection: product form not found for id', formId); return; }

    var emptyField = findEmptyRequiredField(formId);
    if (emptyField) { showWarning(emptyField); return; }

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Processing...';

    var externalFields = document.querySelectorAll('[form="' + formId + '"]');
    var formData = new FormData(form);
    externalFields.forEach(function (el) {
      if (!el.name) return;
      if (el.type === 'file') {
        if (el.files.length > 0) formData.append(el.name, el.files[0]);
      } else {
        formData.append(el.name, el.value);
      }
    });

    fetch(cartAddUrl(), { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          console.error('Classic Collection: add to cart failed', data);
          btn.disabled = false;
          btn.textContent = originalText;
          alert(data.description || 'Something went wrong adding this to your cart. Please try again.');
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('Classic Collection: add to cart request failed', err);
        btn.disabled = false;
        btn.textContent = originalText;
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
  });
})();
